import { gql } from '@apollo/client';

export const DESTROY_AD = gql`
  mutation DestroyAd(
    $adId: ID!
    $deleteReasonId: ID!
    $deleteReasonDescription: String
  ) {
    destroyAd(
      adId: $adId
      deleteReasonId: $deleteReasonId
      deleteReasonDescription: $deleteReasonDescription
    ) {
      entity
      errors {
        message
        path
      }
    }
  }
`;

export const CREATE_CALL = gql`
  mutation CreateCall($adId: ID!, $source: SourceEnum!) {
    createCall(adId: $adId, source: $source) {
      entity
      errors {
        message
        path
      }
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation CreateReport($adId: ID!, $reportReasonId: ID!, $body: String!) {
    createReport(adId: $adId, reportReasonId: $reportReasonId, body: $body) {
      entity
      errors {
        message
        path
      }
    }
  }
`;

export const PROLONG_AD = gql`
  mutation ProlongAd($adId: ID!) {
    prolongAd(adId: $adId) {
      entity
      errors {
        message
        path
      }
    }
  }
`;
